import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=30587c65&scoped=true&"
import script from "./SideNavigation.vue?vue&type=script&lang=ts&"
export * from "./SideNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=30587c65&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30587c65",
  null
  
)

export default component.exports